import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import moment from 'moment';
import axios from 'axios';
import _API from "./lib/api.js";
import _URL from "./lib/url.js";
import _FORM from "./lib/form.js";
import _Cookie from "./lib/cookie";
import _Util from "./lib/util";
import '@/permission'
import _GLOBAL from '@/lib/defaultSetting'
import {
  Tree
} from 'element-ui';
import '@/assets/iconfont/iconfont.css' //引入阿里巴巴图标
import permission from '@/directive/permission/index'
import mixins from "./lib/mixins"
import BrowserInfo from 'brower-compatible';
import {
  vDrag
} from '@/directive/permission/vDrag.js'
import TooltipCard from "@/components/card/tooltip-card.vue"; 

ViewUI.Page.mixins.push({
  mounted() {
    this.$el.classList.add("relative")
  }
})
ViewUI.Input.mixins.push({
  mounted() {
    if(
      ["", true].includes(this.$attrs.allowEmoji) ||
      ["", true].includes(this.$attrs["allow-emoji"])
    ) {
      return;
    }
    let dom = this.$el.querySelector("input") || this.$el.querySelector("textarea");
    dom.func = function({ target }) {
      target.value = target.value.replace(/[\ud800-\udbff][\udc00-\udfff]/g, "");
    };
    dom.addEventListener('input', dom.func, true);
  },
  beforeDestroy() {
    let dom = this.$el.querySelector("input") || this.$el.querySelector("textarea");
    dom.func && dom.removeEventListener('input', dom.func);
  }
});
Vue.component("TooltipCard", TooltipCard);
Vue.use(Tree);
Vue.use(ViewUI);
Vue.use(BrowserInfo);
Vue.prototype.$ajax = axios;
Vue.prototype.$api = _API;
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
Vue.prototype.$api = _API;
//传入文件后缀名，如果是非照片类型，则返回false
Vue.prototype.isImg = _Util.isImg
window.mixins = mixins;
window._FORM = _FORM;
window._Cookie = _Cookie;
window._URL = _URL;
window._Util = _Util;
window._GLOBAL = _GLOBAL;
// 注册全局权限指令
permission.install(Vue)
Vue.directive('drag', vDrag)
window.GlobVue = new Vue({
  router,
  store,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')

Vue.prototype.addLoadingMark = className => {
  document.querySelector(className)?.classList.add("loading-mark");
};
Vue.prototype.removeLoadingMark = () => {
  document.querySelector(".loading-mark")?.classList.remove("loading-mark");
};